module.exports = __webpack_public_path__ + "static/media/GameWin.dbc5f7c7.mp3";